// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/css/" + (chunkId === "4163" ? "async-index" : chunkId) + "." + {"1447": "21d833c9","4163": "f5ff8e05","5091": "558a751d","8591": "be5473cb","9352": "ecb6fdd1",}[chunkId] + ".css"
}